import { checkOutRoutes, RoutesViews } from '@gss/router';

export const checkOutStepsBinds: RoutesViews<typeof checkOutRoutes> = {};
